import { z } from 'zod'

export const vndlyTimesheetFiltersSchema = z
  .object({
    companyIds: z.array(z.number()).min(1),
    dateFrom: z.date(),
    dateTo: z.date(),
  })
  .refine(({ dateFrom, dateTo }) => dateFrom <= dateTo, {
    message: 'End date must be on or after start date',
    path: ['dateTo'],
  })

export type VndlyTimesheetFilters = z.input<typeof vndlyTimesheetFiltersSchema>
